export const popupIncidentType = {
  CONFIRMATION_SELECT_INCIDENT: 'CONFIRMATION_SELECT_INCIDENT',
  CONFIRMATION_INCIDENT: 'CONFIRMATION_INCIDENT',
  SUCCESS_REPORT: 'SUCCESS_REPORT',
};

export type TPopupIncidentType = (typeof popupIncidentType)[keyof typeof popupIncidentType];

export const incidentTypes = {
  noShow: 'no-show',
  walkedOut: 'walked-out',
} as const;

export type TIncidentType = (typeof incidentTypes)[keyof typeof incidentTypes];
